import { ICardElementWithChildren } from "../model/model";

const sortHierarchy = (
  list: ICardElementWithChildren[] | undefined,
  sortFn: (a: ICardElementWithChildren, b: ICardElementWithChildren) => number
) => {
  if (!list) {
    return [];
  }
  const walk = (elems: ICardElementWithChildren[]) => {
    elems.forEach((el) => {
      el.children.sort(sortFn);
      walk(el.children);
    });
  };
  list.sort(sortFn);
  return list;
};

export default sortHierarchy;
